import { Link } from "react-router-dom";
import {
    Phone,
    MessageCircle,
    Zap,
    Clock,
    MapPin,
    ArrowRight,
} from "lucide-react";
import { FiberCanvas } from "../components/FiberCanvas";
import { FadeUp } from "../components/Reveal";
import { BRAND } from "../data/siteData";

export default function Contact() {
    return (
        <section className="relative overflow-hidden" data-testid="contact-page">
            <FiberCanvas className="absolute inset-0 h-full w-full opacity-60" density={22000} />
            <div
                className="pointer-events-none absolute inset-0 bg-gradient-to-b from-[#0B0F19]/60 via-[#0B0F19]/80 to-[#0B0F19]"
                aria-hidden="true"
            />

            <div className="relative mx-auto max-w-5xl px-4 pb-28 pt-36 text-center sm:px-6 sm:pt-44">
                <FadeUp>
                    <span className="inline-flex items-center gap-2 rounded-full border border-[#00F0FF]/30 bg-[#00F0FF]/5 px-4 py-1.5 font-mono text-[11px] font-semibold tracking-[0.28em] text-[#00F0FF]">
                        CONTACT US
                    </span>
                    <h1 className="font-display mt-7 text-4xl font-black leading-[1.02] tracking-tight text-white sm:text-6xl">
                        Ready to <span className="text-gradient-fire">Get Connected?</span>
                    </h1>
                    <p className="mx-auto mt-5 max-w-xl text-base text-slate-300 sm:text-lg">
                        Experience reliable FTTH internet with Eway Fiber Net.
                    </p>
                </FadeUp>

                <FadeUp delay={0.15}>
                    <div className="mt-10 flex flex-wrap items-center justify-center gap-4">
                        <a
                            href={BRAND.phones[0].tel}
                            data-testid="contact-call-button"
                            className="inline-flex items-center gap-2.5 rounded-full bg-[#E61C24] px-8 py-4 text-base font-extrabold text-white shadow-[0_10px_44px_rgba(230,28,36,0.5)] transition-[transform,background-color] duration-200 hover:scale-105 hover:bg-[#C7151C]"
                        >
                            <Phone className="h-5 w-5" />
                            Call Now
                        </a>
                        <a
                            href={BRAND.whatsapp}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="contact-whatsapp-button"
                            className="inline-flex items-center gap-2.5 rounded-full bg-[#1FAF54] px-8 py-4 text-base font-bold text-white transition-[transform,background-color] duration-200 hover:scale-105 hover:bg-[#178f43]"
                        >
                            <MessageCircle className="h-5 w-5" />
                            WhatsApp
                        </a>
                        <Link
                            to="/get-connected"
                            data-testid="contact-get-connection-button"
                            className="group inline-flex items-center gap-2.5 rounded-full border border-white/20 bg-white/5 px-8 py-4 text-base font-bold text-white backdrop-blur-md transition-[border-color,color,transform] duration-200 hover:scale-105 hover:border-[#00F0FF]/70 hover:text-[#00F0FF]"
                        >
                            <Zap className="h-5 w-5" />
                            Get New Connection
                            <ArrowRight className="h-5 w-5 transition-transform duration-200 group-hover:translate-x-1" />
                        </Link>
                    </div>
                </FadeUp>

                <FadeUp delay={0.25}>
                    <div className="mx-auto mt-16 grid max-w-3xl gap-4 sm:grid-cols-3">
                        <div
                            className="glass rounded-3xl p-6"
                            data-testid="contact-info-phones"
                        >
                            <Phone className="mx-auto h-6 w-6 text-[#ff5a60]" />
                            <p className="mt-3 font-mono text-[10px] font-bold tracking-[0.24em] text-slate-400">
                                CALL US
                            </p>
                            <div className="mt-2 space-y-1">
                                {BRAND.phones.map((p) => (
                                    <a
                                        key={p.raw}
                                        href={p.tel}
                                        className="block font-mono text-sm font-bold text-white transition-colors duration-200 hover:text-[#00F0FF]"
                                    >
                                        {p.label}
                                    </a>
                                ))}
                            </div>
                        </div>
                        <div
                            className="glass rounded-3xl p-6"
                            data-testid="contact-info-hours"
                        >
                            <Clock className="mx-auto h-6 w-6 text-[#ff5a60]" />
                            <p className="mt-3 font-mono text-[10px] font-bold tracking-[0.24em] text-slate-400">
                                CUSTOMER CARE
                            </p>
                            <p className="mt-2 text-sm font-bold text-white">
                                {BRAND.careHoursShort}
                            </p>
                        </div>
                        <div
                            className="glass rounded-3xl p-6"
                            data-testid="contact-info-location"
                        >
                            <MapPin className="mx-auto h-6 w-6 text-[#ff5a60]" />
                            <p className="mt-3 font-mono text-[10px] font-bold tracking-[0.24em] text-slate-400">
                                LOCATION
                            </p>
                            <p className="mt-2 text-sm font-bold text-white">
                                {BRAND.location}
                            </p>
                        </div>
                    </div>
                </FadeUp>
            </div>
        </section>
    );
}
